const VideoUrlParser = {};
VideoUrlParser.LINK_URLS = {
  youtube: 'https://www.youtube.com/watch?v=',
  vimeo: 'http://vimeo.com/',
  wistia: 'http://home.wistia.com/medias/',
  loom: 'https://www.loom.com/share/',
  vidyard: 'https://share.vidyard.com/watch/'
};
VideoUrlParser.EMBED_URLS = {
  youtube: 'https://www.youtube.com/embed/',
  vimeo: 'https://player.vimeo.com/video/',
  wistia: 'https://fast.wistia.net/embed/iframe/',
  loom: 'https://www.loom.com/embed/',
  vidyard: 'https://play.vidyard.com/'
};
VideoUrlParser.parse = function (url) {
  let patterns = [{
    provider: 'youtube',
    regex: /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/
  }, {
    provider: 'vimeo',
    regex: /vimeo.*?\/(\d+)(\/)?/i
  }, {
    provider: 'wistia',
    regex: /wistia.*\/([^?]+)\??.*/i
  }, {
    provider: 'loom',
    regex: /(?:use)?loom.*\/([^?]+)\??.*/i
  }, {
    provider: 'vidyard',
    regex: /vidyard.*\/([^?]+)\??.*/i
  }];
  let match,
    response = {
      isValid: false,
      provider: undefined,
      videoID: undefined
    };
  if (url) {
    url = url.trim();
    patterns.some(function (pattern) {
      match = url.match(pattern.regex);
      if (match) {
        response.provider = pattern.provider;
        response.videoID = match[1];
        response.isValid = true;
        return true;
      }
    });
  }
  return response;
};
VideoUrlParser.composerEmbedUrl = function (blockOrUrl) {
  if (typeof blockOrUrl === 'object' && blockOrUrl.type === 'video') {
    if (blockOrUrl.provider && blockOrUrl.videoID) {
      return VideoUrlParser.EMBED_URLS[blockOrUrl.provider] + blockOrUrl.videoID;
    }
  } else if (typeof blockOrUrl === 'string') {
    let parsed = VideoUrlParser.parse(blockOrUrl);
    if (parsed.isValid) {
      return VideoUrlParser.EMBED_URLS[parsed.provider] + parsed.videoID;
    }
  }
};
VideoUrlParser.composerLinkUrl = function (blockOrUrl) {
  if (typeof blockOrUrl === 'object' && blockOrUrl.type === 'video') {
    if (blockOrUrl.provider && blockOrUrl.videoID) {
      return VideoUrlParser.LINK_URLS[blockOrUrl.provider] + blockOrUrl.videoID;
    }
  } else if (typeof blockOrUrl === 'string') {
    let parsed = VideoUrlParser.parse(blockOrUrl);
    if (parsed.isValid) {
      return VideoUrlParser.LINK_URLS[parsed.provider] + parsed.videoID;
    }
  }
};
VideoUrlParser.generateViewContext = function (url) {
  let viewContext = {};
  viewContext.type = 'video';
  viewContext.embedUrl = VideoUrlParser.composerEmbedUrl(url);
  viewContext.url = VideoUrlParser.composerLinkUrl(url);
  return viewContext;
};
export default VideoUrlParser;